var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/opt/build/repo/node_modules/@babel/runtime/helpers/assertThisInitialized");

(function (a, b) {
  'object' == typeof exports && 'object' == typeof module ? module.exports = b() : 'function' == typeof define && define.amd ? define('index', [], b) : 'object' == typeof exports ? exports.index = b() : a.index = b();
})('undefined' == typeof self ? this : self, function () {
  var a = Math.sin,
      b = Math.cos,
      c = Math.PI;
  return function (a) {
    function b(d) {
      if (c[d]) return c[d].exports;
      var e = c[d] = {
        i: d,
        l: !1,
        exports: {}
      };
      return a[d].call(e.exports, e, e.exports, b), e.l = !0, e.exports;
    }

    var c = {};
    return b.m = a, b.c = c, b.d = function (a, c, d) {
      b.o(a, c) || Object.defineProperty(a, c, {
        configurable: !1,
        enumerable: !0,
        get: d
      });
    }, b.n = function (a) {
      var c = a && a.__esModule ? function () {
        return a['default'];
      } : function () {
        return a;
      };
      return b.d(c, 'a', c), c;
    }, b.o = function (a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }, b.p = './', b(b.s = 13);
  }([function (d, e) {
    'use strict';

    Object.defineProperty(e, '__esModule', {
      value: !0
    });

    var f = c,
        g = ['#A45BF1', '#25C6F6', '#72F753', '#F76C88', '#F5F770'],
        h = function h(a, b, c, d, e) {
      return Array.from({
        length: b
      }).map(function (b, f) {
        var g = document.createElement('span'),
            h = e[f % e.length];
        return g.style['background-color'] = h, g.style.width = "".concat(c, "px"), g.style.height = "".concat(c, "px"), g.style.position = 'absolute', g.style.zIndex = d, a.appendChild(g), g;
      });
    },
        i = function i(a) {
      return a * (f / 180);
    },
        j = function j(a, b, c, d) {
      var e = i(a),
          g = i(b);
      return {
        x: 0,
        y: 0,
        wobble: 10 * d(),
        velocity: 0.5 * c + d() * c,
        angle2D: -e + (0.5 * g - d() * g),
        angle3D: -(f / 4) + d() * (f / 2),
        tiltAngle: d() * f
      };
    },
        k = function k(c, d, e) {
      c.physics.x += b(c.physics.angle2D) * c.physics.velocity, c.physics.y += a(c.physics.angle2D) * c.physics.velocity, c.physics.z += a(c.physics.angle3D) * c.physics.velocity, c.physics.wobble += 0.1, c.physics.velocity *= e, c.physics.y += 3, c.physics.tiltAngle += 0.1;
      var f = c.physics;
      var g = f.x,
          h = f.y,
          i = f.tiltAngle,
          j = f.wobble,
          k = g + 10 * b(j),
          l = h + 10 * a(j),
          m = "translate3d(".concat(k, "px, ").concat(l, "px, 0) rotate3d(1, 1, 1, ").concat(i, "rad)");
      c.element.style.transform = m, c.element.style.opacity = 1 - d;
    },
        l = function l(a, b, c, d) {
      var e = d;
      var f = 0;

      var g = function g() {
        b.forEach(function (a) {
          return k(a, f / e, c);
        }), f += 1, f < e ? requestAnimationFrame(g) : b.forEach(function (b) {
          if (b.element.parentNode === a) return a.removeChild(b.element);
        });
      };

      requestAnimationFrame(g);
    };

    e['default'] = function (a) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$elementCount = _ref.elementCount,
          b = _ref$elementCount === void 0 ? 50 : _ref$elementCount,
          _ref$elementSize = _ref.elementSize,
          c = _ref$elementSize === void 0 ? 8 : _ref$elementSize,
          _ref$colors = _ref.colors,
          d = _ref$colors === void 0 ? g : _ref$colors,
          _ref$angle = _ref.angle,
          e = _ref$angle === void 0 ? 90 : _ref$angle,
          _ref$spread = _ref.spread,
          f = _ref$spread === void 0 ? 45 : _ref$spread,
          _ref$decay = _ref.decay,
          i = _ref$decay === void 0 ? 0.9 : _ref$decay,
          _ref$lifetime = _ref.lifetime,
          k = _ref$lifetime === void 0 ? 200 : _ref$lifetime,
          _ref$startVelocity = _ref.startVelocity,
          m = _ref$startVelocity === void 0 ? 35 : _ref$startVelocity,
          _ref$zIndex = _ref.zIndex,
          n = _ref$zIndex === void 0 ? 0 : _ref$zIndex,
          _ref$random = _ref.random,
          o = _ref$random === void 0 ? Math.random : _ref$random;

      var p = h(a, b, c, n, d),
          q = p.map(function (a) {
        return {
          element: a,
          physics: j(e, f, m, o)
        };
      });
      l(a, q, i, k);
    };
  }, function (d, e) {
    'use strict';

    Object.defineProperty(e, '__esModule', {
      value: !0
    });

    var f = c,
        g = ["\uD83D\uDC4D", "\uD83D\uDE0A", "\uD83C\uDF89"],
        h = function h(a, b, c, d, e) {
      return Array.from({
        length: b
      }).map(function (b, f) {
        var g = document.createElement('span'),
            h = e[f % e.length];
        return g.innerHTML = h, g.style.fontSize = "".concat(c, "px"), g.style.position = 'absolute', g.style.zIndex = d, a.appendChild(g), g;
      });
    },
        i = function i(a) {
      return a * (f / 180);
    },
        j = function j(a, b, c, d) {
      var e = i(a),
          g = i(b);
      return {
        x: 0,
        y: 0,
        wobble: 10 * d(),
        velocity: 0.5 * c + d() * c,
        angle2D: -e + (0.5 * g - d() * g),
        angle3D: -(f / 4) + d() * (f / 2),
        tiltAngle: d() * f
      };
    },
        k = function k(c, d, e) {
      c.physics.x += b(c.physics.angle2D) * c.physics.velocity, c.physics.y += a(c.physics.angle2D) * c.physics.velocity, c.physics.wobble += 0, c.physics.velocity *= e, c.physics.y += 5, c.physics.tiltAngle += 0.1;
      var f = c.physics;
      var g = f.x,
          h = f.y,
          i = f.tiltAngle,
          j = "translate3d(".concat(g + 0, "px, ").concat(h + 0, "px, 0) rotate(").concat(i, "rad)");
      c.element.style.transform = j, c.element.style.opacity = 1 - d;
    },
        l = function l(a, b, c, d) {
      var e = d;
      var f = 0;

      var g = function g() {
        b.forEach(function (a) {
          return k(a, f / e, c);
        }), f += 1, f < e ? requestAnimationFrame(g) : b.forEach(function (b) {
          if (b.element.parentNode === a) return a.removeChild(b.element);
        });
      };

      requestAnimationFrame(g);
    };

    e['default'] = function (a) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$angle = _ref2.angle,
          b = _ref2$angle === void 0 ? 90 : _ref2$angle,
          _ref2$decay = _ref2.decay,
          c = _ref2$decay === void 0 ? 0.9 : _ref2$decay,
          _ref2$spread = _ref2.spread,
          d = _ref2$spread === void 0 ? 45 : _ref2$spread,
          _ref2$startVelocity = _ref2.startVelocity,
          e = _ref2$startVelocity === void 0 ? 35 : _ref2$startVelocity,
          _ref2$elementCount = _ref2.elementCount,
          f = _ref2$elementCount === void 0 ? 50 : _ref2$elementCount,
          _ref2$elementSize = _ref2.elementSize,
          i = _ref2$elementSize === void 0 ? 25 : _ref2$elementSize,
          _ref2$lifetime = _ref2.lifetime,
          k = _ref2$lifetime === void 0 ? 200 : _ref2$lifetime,
          _ref2$zIndex = _ref2.zIndex,
          m = _ref2$zIndex === void 0 ? 0 : _ref2$zIndex,
          _ref2$emoji = _ref2.emoji,
          n = _ref2$emoji === void 0 ? g : _ref2$emoji,
          _ref2$random = _ref2.random,
          o = _ref2$random === void 0 ? Math.random : _ref2$random;

      var p = h(a, f, i, m, n),
          q = p.map(function (a) {
        return {
          element: a,
          physics: j(b, d, e, o)
        };
      });
      l(a, q, c, k);
    };
  }, function (a, b, c) {
    'use strict';

    Object.defineProperty(b, '__esModule', {
      value: !0
    });
    var d = c(3),
        e = c.n(d),
        f = c(4),
        g = c.n(f),
        h = c(5),
        i = c.n(h);

    b['default'] = function (a) {
      e.a.loadAnimation({
        container: a,
        renderer: 'svg',
        rendererSettings: {
          className: 'absolutePlayer'
        },
        loop: !1,
        autoplay: !0,
        animationData: g.a,
        onComplete: e.a.destroy()
      });
    };
  }, function (a) {
    a.exports = require('lottie-web');
  }, function (a) {
    a.exports = {
      v: '5.4.1',
      fr: 29.9700012207031,
      ip: 0,
      op: 75.0000030548126,
      w: 1280,
      h: 800,
      nm: 'Confetti',
      ddd: 0,
      assets: [{
        id: 'comp_0',
        layers: [{
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'elems Outlines',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [648, 408, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [640, 400, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [55, 55, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [0, 0], [0, 0]],
                  o: [[0, 0], [0, 0], [0, 0]],
                  v: [[0, -56.517], [65.259, 56.517], [-65.26, 56.517]],
                  c: !0
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 1,
                k: [{
                  i: {
                    x: [0.833],
                    y: [0.833]
                  },
                  o: {
                    x: [0.167],
                    y: [0.167]
                  },
                  n: ['0p833_0p833_0p167_0p167'],
                  t: 0,
                  s: [0.96862745098, 0.423529411765, 0.533333333333, 1],
                  e: [0.701960802078, 0.070588238537, 0.090196080506, 1]
                }, {
                  t: 45.0000018328876
                }],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 25,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 1,
                k: [{
                  i: {
                    x: 0.196,
                    y: 1
                  },
                  o: {
                    x: 0,
                    y: 0
                  },
                  n: '0p196_1_0_0',
                  t: 0,
                  s: [632.987, 391.08],
                  e: [285.686, 74.119],
                  to: [-57.8834648132324, -52.8268241882324],
                  ti: [57.8834648132324, 52.8268241882324]
                }, {
                  t: 60.0000024438501
                }],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 18],
                ix: 1
              },
              s: {
                a: 1,
                k: [{
                  i: {
                    x: [0.833, 0.833],
                    y: [0.833, 0.833]
                  },
                  o: {
                    x: [1, 1],
                    y: [0, 0]
                  },
                  n: ['0p833_0p833_1_0', '0p833_0p833_1_0'],
                  t: 0,
                  s: [33.246, 33.246],
                  e: [0, 0]
                }, {
                  t: 60.0000024438501
                }],
                ix: 3
              },
              r: {
                a: 1,
                k: [{
                  i: {
                    x: [0.529],
                    y: [1]
                  },
                  o: {
                    x: [0.054],
                    y: [0.039]
                  },
                  n: ['0p529_1_0p054_0p039'],
                  t: 0,
                  s: [0],
                  e: [720]
                }, {
                  t: 60.0000024438501
                }],
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                  o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                  v: [[-78.593, 0], [0.001, -78.593], [78.594, 0], [0.001, 78.593]],
                  c: !0
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 1,
                k: [{
                  i: {
                    x: [0.833],
                    y: [0.833]
                  },
                  o: {
                    x: [0.167],
                    y: [0.167]
                  },
                  n: ['0p833_0p833_0p167_0p167'],
                  t: 0,
                  s: [0.643137276173, 0.35686275363, 0.945098042488, 1],
                  e: [0.61960786581, 0.243137255311, 0.996078431606, 1]
                }, {
                  t: 45.0000018328876
                }],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 25,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 1,
                k: [{
                  i: {
                    x: 0.196,
                    y: 1
                  },
                  o: {
                    x: 0,
                    y: 0
                  },
                  n: '0p196_1_0_0',
                  t: 0,
                  s: [632.987, 391.08],
                  e: [629.686, 746.119],
                  to: [-0.55013018846512, 59.1731758117676],
                  ti: [0.55013018846512, -59.1731758117676]
                }, {
                  t: 60.0000024438501
                }],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 1,
                k: [{
                  i: {
                    x: [0.833, 0.833],
                    y: [0.833, 0.833]
                  },
                  o: {
                    x: [1, 1],
                    y: [0, 0]
                  },
                  n: ['0p833_0p833_1_0', '0p833_0p833_1_0'],
                  t: 0,
                  s: [33.246, 33.246],
                  e: [0, 0]
                }, {
                  t: 60.0000024438501
                }],
                ix: 3
              },
              r: {
                a: 1,
                k: [{
                  i: {
                    x: [0.529],
                    y: [1]
                  },
                  o: {
                    x: [0.054],
                    y: [0.039]
                  },
                  n: ['0p529_1_0p054_0p039'],
                  t: 0,
                  s: [0],
                  e: [720]
                }, {
                  t: 60.0000024438501
                }],
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 3',
            np: 2,
            cix: 2,
            ix: 2,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                  o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                  v: [[24.5, -23.5], [24.5, -81.5], [-23.5, -81.5], [-23.5, -23.5], [-81.5, -23.5], [-81.5, 23.5], [-23.5, 23.5], [-23.5, 81.5], [24.5, 81.5], [24.5, 23.5], [81.5, 23.5], [81.5, -23.5]],
                  c: !0
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 1,
                k: [{
                  i: {
                    x: [0.833],
                    y: [0.833]
                  },
                  o: {
                    x: [0.167],
                    y: [0.167]
                  },
                  n: ['0p833_0p833_0p167_0p167'],
                  t: 0,
                  s: [0.960784313725, 0.96862745098, 0.439215686275, 1],
                  e: [0.96928614378, 0.919638156891, 0.541258990765, 1]
                }, {
                  t: 45.0000018328876
                }],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 25,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 1,
                k: [{
                  i: {
                    x: 0.196,
                    y: 1
                  },
                  o: {
                    x: 0,
                    y: 0
                  },
                  n: '0p196_1_0_0',
                  t: 0,
                  s: [632.987, 391.08],
                  e: [1013.686, 133.119],
                  to: [63.4498710632324, -42.9934883117676],
                  ti: [-63.4498710632324, 42.9934883117676]
                }, {
                  t: 60.0000024438501
                }],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 1,
                k: [{
                  i: {
                    x: [0.833, 0.833],
                    y: [0.833, 0.833]
                  },
                  o: {
                    x: [1, 1],
                    y: [0, 0]
                  },
                  n: ['0p833_0p833_1_0', '0p833_0p833_1_0'],
                  t: 0,
                  s: [33.246, 33.246],
                  e: [0, 0]
                }, {
                  t: 60.0000024438501
                }],
                ix: 3
              },
              r: {
                a: 1,
                k: [{
                  i: {
                    x: [0.529],
                    y: [1]
                  },
                  o: {
                    x: [0.054],
                    y: [0.039]
                  },
                  n: ['0p529_1_0p054_0p039'],
                  t: 0,
                  s: [0],
                  e: [720]
                }, {
                  t: 60.0000024438501
                }],
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 5',
            np: 2,
            cix: 2,
            ix: 3,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[-43.406, 0], [0, -43.406], [43.406, 0], [0, 43.406]],
                  o: [[43.406, 0], [0, 43.406], [-43.406, 0], [0, -43.406]],
                  v: [[0, -78.593], [78.593, 0], [0, 78.593], [-78.593, 0]],
                  c: !0
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 1,
                k: [{
                  i: {
                    x: [0.833],
                    y: [0.833]
                  },
                  o: {
                    x: [0.167],
                    y: [0.167]
                  },
                  n: ['0p833_0p833_0p167_0p167'],
                  t: 0,
                  s: [0.145098039216, 0.776470588235, 0.964705882353, 1],
                  e: [0.196078434587, 0.745098054409, 0.996078431606, 1]
                }, {
                  t: 45.0000018328876
                }],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 25,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 1,
                k: [{
                  i: {
                    x: 0.196,
                    y: 1
                  },
                  o: {
                    x: 0,
                    y: 0
                  },
                  n: '0p196_1_0_0',
                  t: 0,
                  s: [632.987, 391.08],
                  e: [137.686, 622.119],
                  to: [-82.5501327514648, 38.5065116882324],
                  ti: [82.5501327514648, -38.5065116882324]
                }, {
                  t: 60.0000024438501
                }],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 1,
                k: [{
                  i: {
                    x: [0.833, 0.833],
                    y: [0.833, 0.833]
                  },
                  o: {
                    x: [1, 1],
                    y: [0, 0]
                  },
                  n: ['0p833_0p833_1_0', '0p833_0p833_1_0'],
                  t: 0,
                  s: [33.246, 33.246],
                  e: [0, 0]
                }, {
                  t: 60.0000024438501
                }],
                ix: 3
              },
              r: {
                a: 1,
                k: [{
                  i: {
                    x: [0.529],
                    y: [1]
                  },
                  o: {
                    x: [0.054],
                    y: [0.039]
                  },
                  n: ['0p529_1_0p054_0p039'],
                  t: 0,
                  s: [0],
                  e: [720]
                }, {
                  t: 60.0000024438501
                }],
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 7',
            np: 2,
            cix: 2,
            ix: 4,
            mn: 'ADBE Vector Group',
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: 'elems greys',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 50,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [653, 411, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [640, 400, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [55, 55, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [0, 0], [0, 0]],
                  o: [[0, 0], [0, 0], [0, 0]],
                  v: [[0, -56.517], [65.259, 56.517], [-65.26, 56.517]],
                  c: !0
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.903109669685, 0.903109669685, 0.903109669685, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 25,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 1,
                k: [{
                  i: {
                    x: 0.196,
                    y: 1
                  },
                  o: {
                    x: 0,
                    y: 0
                  },
                  n: '0p196_1_0_0',
                  t: 0,
                  s: [632.987, 391.08],
                  e: [277.686, 123.119],
                  to: [-59.216796875, -44.66015625],
                  ti: [59.216796875, 44.66015625]
                }, {
                  t: 60.0000024438501
                }],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 18],
                ix: 1
              },
              s: {
                a: 1,
                k: [{
                  i: {
                    x: [0.833, 0.833],
                    y: [0.833, 0.833]
                  },
                  o: {
                    x: [1, 1],
                    y: [0, 0]
                  },
                  n: ['0p833_0p833_1_0', '0p833_0p833_1_0'],
                  t: 0,
                  s: [33.246, 33.246],
                  e: [0, 0]
                }, {
                  t: 60.0000024438501
                }],
                ix: 3
              },
              r: {
                a: 1,
                k: [{
                  i: {
                    x: [0.529],
                    y: [1]
                  },
                  o: {
                    x: [0.054],
                    y: [0.039]
                  },
                  n: ['0p529_1_0p054_0p039'],
                  t: 0,
                  s: [0],
                  e: [720]
                }, {
                  t: 60.0000024438501
                }],
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 2,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                  o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                  v: [[-78.593, 0], [0.001, -78.593], [78.594, 0], [0.001, 78.593]],
                  c: !0
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.901960790157, 0.901960790157, 0.901960790157, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 25,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 1,
                k: [{
                  i: {
                    x: 0.196,
                    y: 1
                  },
                  o: {
                    x: 0,
                    y: 0
                  },
                  n: '0p196_1_0_0',
                  t: 0,
                  s: [632.987, 391.08],
                  e: [648.686, 706.119],
                  to: [2.61653637886047, 52.5065116882324],
                  ti: [-2.61653637886047, -52.5065116882324]
                }, {
                  t: 60.0000024438501
                }],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 1,
                k: [{
                  i: {
                    x: [0.833, 0.833],
                    y: [0.833, 0.833]
                  },
                  o: {
                    x: [1, 1],
                    y: [0, 0]
                  },
                  n: ['0p833_0p833_1_0', '0p833_0p833_1_0'],
                  t: 0,
                  s: [33.246, 33.246],
                  e: [0, 0]
                }, {
                  t: 60.0000024438501
                }],
                ix: 3
              },
              r: {
                a: 1,
                k: [{
                  i: {
                    x: [0.529],
                    y: [1]
                  },
                  o: {
                    x: [0.054],
                    y: [0.039]
                  },
                  n: ['0p529_1_0p054_0p039'],
                  t: 0,
                  s: [0],
                  e: [720]
                }, {
                  t: 60.0000024438501
                }],
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 3',
            np: 2,
            cix: 2,
            ix: 2,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                  o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                  v: [[24.5, -23.5], [24.5, -81.5], [-23.5, -81.5], [-23.5, -23.5], [-81.5, -23.5], [-81.5, 23.5], [-23.5, 23.5], [-23.5, 81.5], [24.5, 81.5], [24.5, 23.5], [81.5, 23.5], [81.5, -23.5]],
                  c: !0
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.901960790157, 0.901960790157, 0.901960790157, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 25,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 1,
                k: [{
                  i: {
                    x: 0.196,
                    y: 1
                  },
                  o: {
                    x: 0,
                    y: 0
                  },
                  n: '0p196_1_0_0',
                  t: 0,
                  s: [632.987, 391.08],
                  e: [992.686, 193.119],
                  to: [59.9498710632324, -32.9934883117676],
                  ti: [-59.9498710632324, 32.9934883117676]
                }, {
                  t: 60.0000024438501
                }],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 1,
                k: [{
                  i: {
                    x: [0.833, 0.833],
                    y: [0.833, 0.833]
                  },
                  o: {
                    x: [1, 1],
                    y: [0, 0]
                  },
                  n: ['0p833_0p833_1_0', '0p833_0p833_1_0'],
                  t: 0,
                  s: [33.246, 33.246],
                  e: [0, 0]
                }, {
                  t: 60.0000024438501
                }],
                ix: 3
              },
              r: {
                a: 1,
                k: [{
                  i: {
                    x: [0.529],
                    y: [1]
                  },
                  o: {
                    x: [0.054],
                    y: [0.039]
                  },
                  n: ['0p529_1_0p054_0p039'],
                  t: 0,
                  s: [0],
                  e: [720]
                }, {
                  t: 60.0000024438501
                }],
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 5',
            np: 2,
            cix: 2,
            ix: 3,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[-43.406, 0], [0, -43.406], [43.406, 0], [0, 43.406]],
                  o: [[43.406, 0], [0, 43.406], [-43.406, 0], [0, -43.406]],
                  v: [[0, -78.593], [78.593, 0], [0, 78.593], [-78.593, 0]],
                  c: !0
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.901960790157, 0.901960790157, 0.901960790157, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 25,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 1,
                k: [{
                  i: {
                    x: 0.196,
                    y: 1
                  },
                  o: {
                    x: 0,
                    y: 0
                  },
                  n: '0p196_1_0_0',
                  t: 0,
                  s: [632.987, 391.08],
                  e: [171.686, 618.119],
                  to: [-76.8834609985352, 37.83984375],
                  ti: [76.8834609985352, -37.83984375]
                }, {
                  t: 60.0000024438501
                }],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 1,
                k: [{
                  i: {
                    x: [0.833, 0.833],
                    y: [0.833, 0.833]
                  },
                  o: {
                    x: [1, 1],
                    y: [0, 0]
                  },
                  n: ['0p833_0p833_1_0', '0p833_0p833_1_0'],
                  t: 0,
                  s: [33.246, 33.246],
                  e: [0, 0]
                }, {
                  t: 60.0000024438501
                }],
                ix: 3
              },
              r: {
                a: 1,
                k: [{
                  i: {
                    x: [0.529],
                    y: [1]
                  },
                  o: {
                    x: [0.054],
                    y: [0.039]
                  },
                  n: ['0p529_1_0p054_0p039'],
                  t: 0,
                  s: [0],
                  e: [720]
                }, {
                  t: 60.0000024438501
                }],
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 7',
            np: 2,
            cix: 2,
            ix: 4,
            mn: 'ADBE Vector Group',
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }]
      }, {
        id: 'comp_1',
        layers: [{
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'twiggle Outlines 10',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 20,
              ix: 10
            },
            p: {
              a: 0,
              k: [640, 399, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [545, 457, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [74.124, 74.124, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [-54.167, -22.916], [-31.25, 25], [-17.709, 23.959], [-17.709, 37.5], [0, 0]],
                  o: [[0, 0], [54.166, 22.917], [31.25, -25], [17.708, -23.958], [17.708, -37.5], [0, 0]],
                  v: [[-141.771, 120.599], [-86.354, 90.057], [-33.229, 21.307], [48.021, -3.693], [60.281, -83.099], [141.771, -118.996]],
                  c: !1
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.901960790157, 0.901960790157, 0.901960790157, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 50,
                ix: 4
              },
              w: {
                a: 0,
                k: 8,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [788.771, 279.401],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'tm',
            s: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 25,
                s: [0],
                e: [100]
              }, {
                t: 38.0000015477717
              }],
              ix: 1
            },
            e: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 12,
                s: [0],
                e: [100]
              }, {
                t: 38.0000015477717
              }],
              ix: 2
            },
            o: {
              a: 0,
              k: 0,
              ix: 3
            },
            m: 1,
            ix: 2,
            nm: 'Trim Paths 1',
            mn: 'ADBE Vector Filter - Trim',
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: 'twiggle Outlines 9',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 308,
              ix: 10
            },
            p: {
              a: 0,
              k: [640, 399, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [545, 457, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [74.124, 74.124, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [-54.167, -22.916], [-31.25, 25], [-17.709, 23.959], [-17.709, 37.5], [0, 0]],
                  o: [[0, 0], [54.166, 22.917], [31.25, -25], [17.708, -23.958], [17.708, -37.5], [0, 0]],
                  v: [[-141.771, 120.599], [-86.354, 90.057], [-33.229, 21.307], [48.021, -3.693], [60.281, -83.099], [141.771, -118.996]],
                  c: !1
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.901960790157, 0.901960790157, 0.901960790157, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 50,
                ix: 4
              },
              w: {
                a: 0,
                k: 8,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [788.771, 279.401],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'tm',
            s: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 25,
                s: [0],
                e: [100]
              }, {
                t: 38.0000015477717
              }],
              ix: 1
            },
            e: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 12,
                s: [0],
                e: [100]
              }, {
                t: 38.0000015477717
              }],
              ix: 2
            },
            o: {
              a: 0,
              k: 0,
              ix: 3
            },
            m: 1,
            ix: 2,
            nm: 'Trim Paths 1',
            mn: 'ADBE Vector Filter - Trim',
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: 'twiggle Outlines 8',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 236,
              ix: 10
            },
            p: {
              a: 0,
              k: [640, 399, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [545, 457, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [74.124, 74.124, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [-54.167, -22.916], [-31.25, 25], [-17.709, 23.959], [-17.709, 37.5], [0, 0]],
                  o: [[0, 0], [54.166, 22.917], [31.25, -25], [17.708, -23.958], [17.708, -37.5], [0, 0]],
                  v: [[-141.771, 120.599], [-86.354, 90.057], [-33.229, 21.307], [48.021, -3.693], [60.281, -83.099], [141.771, -118.996]],
                  c: !1
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.901960790157, 0.901960790157, 0.901960790157, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 50,
                ix: 4
              },
              w: {
                a: 0,
                k: 8,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [788.771, 279.401],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'tm',
            s: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 25,
                s: [0],
                e: [100]
              }, {
                t: 38.0000015477717
              }],
              ix: 1
            },
            e: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 12,
                s: [0],
                e: [100]
              }, {
                t: 38.0000015477717
              }],
              ix: 2
            },
            o: {
              a: 0,
              k: 0,
              ix: 3
            },
            m: 1,
            ix: 2,
            nm: 'Trim Paths 1',
            mn: 'ADBE Vector Filter - Trim',
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: 'twiggle Outlines 7',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 164,
              ix: 10
            },
            p: {
              a: 0,
              k: [640, 399, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [545, 457, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [74.124, 74.124, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [-54.167, -22.916], [-31.25, 25], [-17.709, 23.959], [-17.709, 37.5], [0, 0]],
                  o: [[0, 0], [54.166, 22.917], [31.25, -25], [17.708, -23.958], [17.708, -37.5], [0, 0]],
                  v: [[-141.771, 120.599], [-86.354, 90.057], [-33.229, 21.307], [48.021, -3.693], [60.281, -83.099], [141.771, -118.996]],
                  c: !1
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.901960790157, 0.901960790157, 0.901960790157, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 50,
                ix: 4
              },
              w: {
                a: 0,
                k: 8,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [788.771, 279.401],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'tm',
            s: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 25,
                s: [0],
                e: [100]
              }, {
                t: 38.0000015477717
              }],
              ix: 1
            },
            e: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 12,
                s: [0],
                e: [100]
              }, {
                t: 38.0000015477717
              }],
              ix: 2
            },
            o: {
              a: 0,
              k: 0,
              ix: 3
            },
            m: 1,
            ix: 2,
            nm: 'Trim Paths 1',
            mn: 'ADBE Vector Filter - Trim',
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 5,
          ty: 4,
          nm: 'twiggle Outlines 6',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 92,
              ix: 10
            },
            p: {
              a: 0,
              k: [640, 399, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [545, 457, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [74.124, 74.124, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [-54.167, -22.916], [-31.25, 25], [-17.709, 23.959], [-17.709, 37.5], [0, 0]],
                  o: [[0, 0], [54.166, 22.917], [31.25, -25], [17.708, -23.958], [17.708, -37.5], [0, 0]],
                  v: [[-141.771, 120.599], [-86.354, 90.057], [-33.229, 21.307], [48.021, -3.693], [60.281, -83.099], [141.771, -118.996]],
                  c: !1
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.901960790157, 0.901960790157, 0.901960790157, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 50,
                ix: 4
              },
              w: {
                a: 0,
                k: 8,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [788.771, 279.401],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'tm',
            s: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 25,
                s: [0],
                e: [100]
              }, {
                t: 38.0000015477717
              }],
              ix: 1
            },
            e: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 12,
                s: [0],
                e: [100]
              }, {
                t: 38.0000015477717
              }],
              ix: 2
            },
            o: {
              a: 0,
              k: 0,
              ix: 3
            },
            m: 1,
            ix: 2,
            nm: 'Trim Paths 1',
            mn: 'ADBE Vector Filter - Trim',
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 6,
          ty: 4,
          nm: 'twiggle Outlines 5',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 360,
              ix: 10
            },
            p: {
              a: 0,
              k: [640, 400, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [640, 400, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [74.124, 74.124, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [-54.167, -22.916], [-31.25, 25], [-17.709, 23.959], [-17.709, 37.5], [0, 0]],
                  o: [[0, 0], [54.166, 22.917], [31.25, -25], [17.708, -23.958], [17.708, -37.5], [0, 0]],
                  v: [[-141.771, 120.599], [-86.354, 90.057], [-33.229, 21.307], [48.021, -3.693], [60.281, -83.099], [141.771, -118.996]],
                  c: !1
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.96862745285, 0.423529416323, 0.533333361149, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 8,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [788.771, 279.401],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'tm',
            s: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 13,
                s: [0],
                e: [100]
              }, {
                t: 30.0000012219251
              }],
              ix: 1
            },
            e: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 0,
                s: [0],
                e: [100]
              }, {
                t: 30.0000012219251
              }],
              ix: 2
            },
            o: {
              a: 0,
              k: 0,
              ix: 3
            },
            m: 1,
            ix: 2,
            nm: 'Trim Paths 1',
            mn: 'ADBE Vector Filter - Trim',
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 7,
          ty: 4,
          nm: 'twiggle Outlines 4',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 288,
              ix: 10
            },
            p: {
              a: 0,
              k: [640, 400, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [640, 400, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [74.124, 74.124, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [-54.167, -22.916], [-31.25, 25], [-17.709, 23.959], [-17.709, 37.5], [0, 0]],
                  o: [[0, 0], [54.166, 22.917], [31.25, -25], [17.708, -23.958], [17.708, -37.5], [0, 0]],
                  v: [[-141.771, 120.599], [-86.354, 90.057], [-33.229, 21.307], [48.021, -3.693], [60.281, -83.099], [141.771, -118.996]],
                  c: !1
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.643137276173, 0.35686275363, 0.945098042488, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 8,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [788.771, 279.401],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'tm',
            s: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 13,
                s: [0],
                e: [100]
              }, {
                t: 30.0000012219251
              }],
              ix: 1
            },
            e: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 0,
                s: [0],
                e: [100]
              }, {
                t: 30.0000012219251
              }],
              ix: 2
            },
            o: {
              a: 0,
              k: 0,
              ix: 3
            },
            m: 1,
            ix: 2,
            nm: 'Trim Paths 1',
            mn: 'ADBE Vector Filter - Trim',
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 8,
          ty: 4,
          nm: 'twiggle Outlines 3',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 216,
              ix: 10
            },
            p: {
              a: 0,
              k: [640, 400, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [640, 400, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [74.124, 74.124, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [-54.167, -22.916], [-31.25, 25], [-17.709, 23.959], [-17.709, 37.5], [0, 0]],
                  o: [[0, 0], [54.166, 22.917], [31.25, -25], [17.708, -23.958], [17.708, -37.5], [0, 0]],
                  v: [[-141.771, 120.599], [-86.354, 90.057], [-33.229, 21.307], [48.021, -3.693], [60.281, -83.099], [141.771, -118.996]],
                  c: !1
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.447058826685, 0.96862745285, 0.32549020648, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 8,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [788.771, 279.401],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'tm',
            s: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 13,
                s: [0],
                e: [100]
              }, {
                t: 30.0000012219251
              }],
              ix: 1
            },
            e: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 0,
                s: [0],
                e: [100]
              }, {
                t: 30.0000012219251
              }],
              ix: 2
            },
            o: {
              a: 0,
              k: 0,
              ix: 3
            },
            m: 1,
            ix: 2,
            nm: 'Trim Paths 1',
            mn: 'ADBE Vector Filter - Trim',
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 9,
          ty: 4,
          nm: 'twiggle Outlines 2',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 144,
              ix: 10
            },
            p: {
              a: 0,
              k: [640, 400, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [640, 400, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [74.124, 74.124, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [-54.167, -22.916], [-31.25, 25], [-17.709, 23.959], [-17.709, 37.5], [0, 0]],
                  o: [[0, 0], [54.166, 22.917], [31.25, -25], [17.708, -23.958], [17.708, -37.5], [0, 0]],
                  v: [[-141.771, 120.599], [-86.354, 90.057], [-33.229, 21.307], [48.021, -3.693], [60.281, -83.099], [141.771, -118.996]],
                  c: !1
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.145098039216, 0.776470588235, 0.964705882353, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 8,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [788.771, 279.401],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'tm',
            s: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 13,
                s: [0],
                e: [100]
              }, {
                t: 30.0000012219251
              }],
              ix: 1
            },
            e: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 0,
                s: [0],
                e: [100]
              }, {
                t: 30.0000012219251
              }],
              ix: 2
            },
            o: {
              a: 0,
              k: 0,
              ix: 3
            },
            m: 1,
            ix: 2,
            nm: 'Trim Paths 1',
            mn: 'ADBE Vector Filter - Trim',
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 10,
          ty: 4,
          nm: 'twiggle Outlines',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 72,
              ix: 10
            },
            p: {
              a: 0,
              k: [640, 400, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [640, 400, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [74.124, 74.124, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: 'gr',
            it: [{
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [-54.167, -22.916], [-31.25, 25], [-17.709, 23.959], [-17.709, 37.5], [0, 0]],
                  o: [[0, 0], [54.166, 22.917], [31.25, -25], [17.708, -23.958], [17.708, -37.5], [0, 0]],
                  v: [[-141.771, 120.599], [-86.354, 90.057], [-33.229, 21.307], [48.021, -3.693], [60.281, -83.099], [141.771, -118.996]],
                  c: !1
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: !1
            }, {
              ty: 'st',
              c: {
                a: 0,
                k: [0.960784316063, 0.96862745285, 0.439215689898, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 8,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 10,
              ml2: {
                a: 0,
                k: 10,
                ix: 8
              },
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: !1
            }, {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: !1
            }, {
              ty: 'tr',
              p: {
                a: 0,
                k: [788.771, 279.401],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }],
            nm: 'Group 1',
            np: 3,
            cix: 2,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: !1
          }, {
            ty: 'tm',
            s: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 13,
                s: [0],
                e: [100]
              }, {
                t: 30.0000012219251
              }],
              ix: 1
            },
            e: {
              a: 1,
              k: [{
                i: {
                  x: [0.833],
                  y: [0.833]
                },
                o: {
                  x: [0.167],
                  y: [0.167]
                },
                n: ['0p833_0p833_0p167_0p167'],
                t: 0,
                s: [0],
                e: [100]
              }, {
                t: 30.0000012219251
              }],
              ix: 2
            },
            o: {
              a: 0,
              k: 0,
              ix: 3
            },
            m: 1,
            ix: 2,
            nm: 'Trim Paths 1',
            mn: 'ADBE Vector Filter - Trim',
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }]
      }],
      layers: [{
        ddd: 0,
        ind: 2,
        ty: 0,
        nm: 'layer 1',
        refId: 'comp_0',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [660, 420, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [640, 400, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [67.505, 67.505, 100],
            ix: 6
          }
        },
        ao: 0,
        w: 1280,
        h: 800,
        ip: 0,
        op: 300.00001221925,
        st: 0,
        bm: 0
      }, {
        ddd: 0,
        ind: 3,
        ty: 0,
        nm: 'layer 1',
        refId: 'comp_0',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 215,
            ix: 10
          },
          p: {
            a: 0,
            k: [660, 420, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [640, 400, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [67.505, 67.505, 100],
            ix: 6
          }
        },
        ao: 0,
        w: 1280,
        h: 800,
        ip: 4.00000016292334,
        op: 304.000012382174,
        st: 4.00000016292334,
        bm: 0
      }, {
        ddd: 0,
        ind: 4,
        ty: 0,
        nm: 'layer 1',
        refId: 'comp_0',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 58,
            ix: 10
          },
          p: {
            a: 0,
            k: [660, 420, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [640, 400, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [82.5, 82.5, 100],
            ix: 6
          }
        },
        ao: 0,
        w: 1280,
        h: 800,
        ip: 9.00000036657752,
        op: 309.000012585828,
        st: 9.00000036657752,
        bm: 0
      }, {
        ddd: 0,
        ind: 6,
        ty: 0,
        nm: 'Twiggles',
        refId: 'comp_1',
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [660, 420, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [640, 400, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [67.505, 67.505, 100],
            ix: 6
          }
        },
        ao: 0,
        w: 1280,
        h: 800,
        ip: 6.00000024438501,
        op: 306.000012463636,
        st: 6.00000024438501,
        bm: 0
      }],
      markers: []
    };
  }, function () {}, function (a) {
    a.exports = require('react');
  }, function (a, b, c) {
    'use strict';

    Object.defineProperty(b, '__esModule', {
      value: !0
    }), c.d(b, 'default', function () {
      return n;
    });

    var d = c(6),
        e = c.n(d),
        f = c(8),
        g = c.n(f),
        h = c(0),
        i = c(1),
        j = c(2),
        k = Object.assign || function (a) {
      for (var b, c = 1; c < arguments.length; c++) {
        for (var d in b = arguments[c], b) {
          Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
        }
      }

      return a;
    };

    var l = {
      type: 'spring',
      stiffness: 200,
      damping: 2
    },
        m = g.a.div({
      confetti: {
        y: 5,
        transition: k({}, l)
      },
      emoji: {
        y: 5,
        transition: k({}, l)
      },
      memphis: {
        scale: 1.1,
        transition: k({}, l)
      },
      punished: {
        x: 5,
        transition: k({}, l)
      },
      resting: {
        y: 0,
        x: 0,
        scale: 1,
        transition: k({}, l)
      }
    });

    var n =
    /*#__PURE__*/
    function (_d$Component) {
      _inherits(n, _d$Component);

      function n() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, n);

        var b;

        for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
          a[_key] = arguments[_key];
        }

        return _possibleConstructorReturn(_this, (b = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(n)).call.apply(_getPrototypeOf2, [this].concat(a))), Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), 'state', {
          enumerable: !0,
          writable: !0,
          value: {
            state: 'resting'
          }
        }), Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), 'rewardMe', {
          enumerable: !0,
          writable: !0,
          value: function value() {
            var a = _this.props;
            var b = a.type,
                c = a.config,
                d = [_this.container, c];

            switch (b) {
              case 'confetti':
                {
                  _this.handleAnimation(b), Object(h['default']).apply(void 0, d);
                  break;
                }

              case 'emoji':
                {
                  _this.handleAnimation(b), Object(i['default']).apply(void 0, d);
                  break;
                }

              case 'memphis':
                {
                  _this.handleAnimation(b), Object(j['default']).apply(void 0, d);
                  break;
                }

              default:
            }
          }
        }), Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), 'punishMe', {
          enumerable: !0,
          writable: !0,
          value: function value() {
            _this.handlePunishAnimation();
          }
        }), Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), 'rest', {
          enumerable: !0,
          writable: !0,
          value: function value() {
            setTimeout(function () {
              _this.setState({
                state: 'resting'
              });
            }, 100);
          }
        }), Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), 'handleAnimation', {
          enumerable: !0,
          writable: !0,
          value: function value(a) {
            _this.setState({
              state: a
            }, function () {
              _this.rest();
            });
          }
        }), Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), 'handlePunishAnimation', {
          enumerable: !0,
          writable: !0,
          value: function value() {
            _this.setState({
              state: 'punished'
            }, function () {
              _this.rest();
            });
          }
        }), b));
      }

      _createClass(n, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          var a = this.props,
              b = a.config;
          var c = b === void 0 ? {} : b,
              e = a.children;
          var f = c.springAnimation;
          var g = this.state.state;
          return Object(d.createElement)('span', null, Object(d.createElement)('div', {
            ref: function ref(a) {
              _this2.container = a;
            }
          }), Object(d.createElement)(m, {
            pose: (!(f !== void 0) || f) && g
          }, e));
        }
      }]);

      return n;
    }(d.Component);
  }, function (a) {
    a.exports = require('react-pose');
  },,,,, function (a, b, c) {
    a.exports = c(14);
  }, function (a, b, c) {
    'use strict';

    Object.defineProperty(b, '__esModule', {
      value: !0
    });
    var d = c(7);
    b['default'] = d['default'];
  }]);
});